import {Component, Input, OnInit} from '@angular/core';
import {FormControlName, UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-number-integer-field',
  templateUrl: './number-integer-field.component.html',
  styleUrls: ['./number-integer-field.component.scss'],
})
export class NumberIntegerFieldComponent implements OnInit {
  @Input() inputName: string;
  @Input() form: UntypedFormGroup;
  @Input() label: string;
  @Input() isError: boolean;
  @Input() placeholder: string;
  @Input() preValue: string;


  constructor() { }

  ngOnInit() {
    if (this.preValue && this.form && this.inputName) {
      this.form.get(this.inputName)?.setValue(this.preValue);
    }
  }

}
